import React, {useState} from 'react';
import {Tab, Tabs, AppBar} from '@material-ui/core';

import MusicThree from './music/MusicThree';
import MusicOne from './music/MusicOne';
import MusicTwo from './music/MusicTwo';

import './MusicTab.css';

const MusicTab = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const handleChange = (e, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <AppBar position="static" className="musicTab">
        <Tabs
          value={selectedTab}
          onChange={handleChange}
          className="musicTab__container"
          centered
        >
          <Tab label="Ikinyafu" />
          <Tab label="Katerina" />
          <Tab label="Katapilla" />
        </Tabs>
      </AppBar>
      {selectedTab === 0 && <MusicOne />}
      {selectedTab === 1 && <MusicTwo />}
      {selectedTab === 2 && <MusicThree />}
    </>
  );
};
export default MusicTab;
